import type { MusicSource } from '@qlk/shared';
import { MUSIC_SOURCE_KIND_LABEL, SAP_HET_HAN_NGAY } from '@qlk/shared';
import { Library } from 'lucide-react';

import { EmptyState, KhoiMuc, StatusBadge } from '../../../ui/index.js';
import { ngayVn, soNgayConLai, TONE_NGUON } from './dinhDang.js';

export interface TheNguonNhacProps {
  nguon: MusicSource[];
  dangTai: boolean;
}

/** Thẻ đối tác kho nhạc: điều khoản, yêu cầu ghi credit và hạn giấy phép. */
export function TheNguonNhac({ nguon, dangTai }: TheNguonNhacProps) {
  const hopTac = nguon.filter((n) => n.kind !== 'own');

  return (
    <KhoiMuc tieuDe="Đối tác kho nhạc">
      {dangTai && <p className="text-co-ban text-chu-phu">Đang tải nguồn nhạc…</p>}

      {!dangTai && hopTac.length === 0 && (
        <div className="rounded-the border border-vien bg-be-mat">
          <EmptyState
            icon={Library}
            title="Chưa có kho nhạc hợp tác"
            description="Thêm nguồn nhạc đối tác để theo dõi giấy phép và yêu cầu ghi credit."
          />
        </div>
      )}

      <div className="grid grid-cols-1 gap-4 @min-[700px]/noi-dung:grid-cols-2">
        {hopTac.map((n) => {
          const conLai = soNgayConLai(n.licenseEndDate);
          const tone =
            conLai === null
              ? 'ok'
              : conLai < 0
                ? 'bad'
                : conLai <= SAP_HET_HAN_NGAY
                  ? 'warn'
                  : 'ok';

          return (
            <article key={n.id} className="rounded-the border border-vien bg-be-mat p-6">
              <div className="flex flex-wrap items-center gap-3">
                <h3 className="text-tieu-de-khoi font-semibold text-chu">{n.name}</h3>
                <StatusBadge tone={TONE_NGUON[n.kind]} cham={false}>
                  {MUSIC_SOURCE_KIND_LABEL[n.kind]}
                </StatusBadge>
              </div>

              <p className="mt-2 text-co-ban text-chu-phu">
                {n.licenseTerms ?? 'Chưa ghi điều khoản.'}
              </p>

              <dl className="mt-4 grid grid-cols-2 gap-3 text-co-ban">
                <div>
                  <dt className="text-phu text-chu-mo">Số bài</dt>
                  <dd className="so-lieu font-semibold text-chu">{n.trackCount}</dd>
                </div>
                <div>
                  <dt className="text-phu text-chu-mo">Giấy phép</dt>
                  <dd>
                    <StatusBadge tone={tone}>
                      {n.licenseEndDate
                        ? `${conLai !== null && conLai < 0 ? 'Hết hạn' : 'Đến'} ${ngayVn(n.licenseEndDate)}`
                        : 'Không giới hạn'}
                    </StatusBadge>
                  </dd>
                </div>
              </dl>

              {n.creditRequired && (
                <p className="mt-4 rounded-[10px] bg-warn-nen px-3 py-2 text-phu text-warn-chu">
                  Bắt buộc ghi credit: {n.creditTemplate ?? 'theo mẫu của đối tác'}
                </p>
              )}
            </article>
          );
        })}
      </div>
    </KhoiMuc>
  );
}
